import { Action } from '@ngrx/store';
import { IExpOrg } from '../../../../commons';

export enum ExpOrgActionTypes {
  LoadExpOrgState = '[ExpOrg] Load ExpOrg State',
  LoadExpOrgStateSuccess = '[ExpOrg] Load ExpOrg State Success',
  LoadExpOrgStateFail = '[ExpOrg] Load ExpOrg State Fail',
  ExpOrgScreenErrorReset = '[ExpOrg] ExpOrg Screen Error Reset'

}

export class LoadExpOrgState implements Action {
  readonly type = ExpOrgActionTypes.LoadExpOrgState;
}

export class LoadExpOrgStateSuccess implements Action {
  readonly type = ExpOrgActionTypes.LoadExpOrgStateSuccess;
  constructor(public payload: IExpOrg ) {}
}

export class LoadExpOrgStateFail implements Action {
  readonly type = ExpOrgActionTypes.LoadExpOrgStateFail;
  constructor(public payload: any) {}
}

export class ExpOrgScreenErrorReset implements Action {
  readonly type = ExpOrgActionTypes.ExpOrgScreenErrorReset;
}

export type ExpOrgActions = 
  LoadExpOrgState
  | LoadExpOrgStateSuccess
  | LoadExpOrgStateFail
  | ExpOrgScreenErrorReset;